import Rarity from "../../helper/Rarity";
import CraftingCategory from "../../helper/CraftingCategory";

export default {
    ASHES: {
        item: 'Ashes',
        category: CraftingCategory.CRAFTING_MATERIALS,
        DC: 10,
        maxAmount: 10,
        rarity: Rarity.EVERYDAY,
        cost: 1,
        weight: 0.1,
    },



    BEAR_HIDE: {
        item: 'Bear Hide',
        category: CraftingCategory.HIDES_AND_ANIMAL_PARTS,
        DC: 10,
        maxAmount: 3,
        rarity: Rarity.COMMON,
        cost: 30,
        weight: 6,
    },
    BEAST_BONES: {
        item: 'Beast Bones',
        category: CraftingCategory.HIDES_AND_ANIMAL_PARTS,
        rarity: Rarity.COMMON,
        cost: 8,
        weight: 4,
    },



    COAL: {
        item: 'Coal',
        category: CraftingCategory.CRAFTING_MATERIALS,
        DC: 14,
        maxAmount: 10,
        rarity: Rarity.COMMON,
        cost: 1,
        weight: 0.1,
    },
    COTTON: {
        item: 'Cotton',
        category: CraftingCategory.CRAFTING_MATERIALS,
        DC: 12,
        maxAmount: 10,
        rarity: Rarity.COMMON,
        cost: 1,
        weight: 0.1,
    },
    COW_HIDE: {
        item: 'Cow Hide',
        category: CraftingCategory.HIDES_AND_ANIMAL_PARTS,
        rarity: Rarity.COMMON,
        cost: 10,
        weight: 5,
    },



    DARK_IRON: {
        item: 'Dark Iron',
        category: CraftingCategory.INGOTS_AND_MINERALS,
        DC: 18,
        maxAmount: 6,
        rarity: Rarity.RARE,
        cost: 52,
        weight: 1.5,
    },
    DARK_STEEL: {
        item: 'Dark Steel',
        category: CraftingCategory.INGOTS_AND_MINERALS,
        rarity: Rarity.RARE,
        cost: 82,
        weight: 1,
    },
    DARKENING_OIL: {
        item: 'Darkening Oil',
        category: CraftingCategory.ALCHEMICAL_TREATMENTS,
        DC: 16,
        maxAmount: 6,
        rarity: Rarity.UNCOMMON,
        cost: 24,
        weight: 0.1,
    },
    DIMERITIUM: {
        item: 'Dimeritium',
        category: CraftingCategory.INGOTS_AND_MINERALS,
        rarity: Rarity.RARE,
        cost: 240,
        weight: 1,
    },
    DRAKE_OIL: {
        item: 'Drake Oil',
        category: CraftingCategory.ALCHEMICAL_TREATMENTS,
        DC: 16,
        maxAmount: 6,
        rarity: Rarity.UNCOMMON,
        cost: 45,
        weight: 0.1,
    },
    DOUBLE_WOVEN_LINEN: {
        item: 'Double Woven Linen',
        category: CraftingCategory.CRAFTING_MATERIALS,
        rarity: Rarity.UNCOMMON,
        cost: 22,
        weight: 0.1,
    },
    DRACONID_LEATHER: {
        item: 'Draconid Leather',
        category: CraftingCategory.HIDES_AND_ANIMAL_PARTS,
        rarity: Rarity.RARE,
        cost: 58,
        weight: 5,
    },
    DRACONID_SCALES: {
        item: 'Draconid Scales',
        category: CraftingCategory.HIDES_AND_ANIMAL_PARTS,
        maxAmount: 6,
        rarity: Rarity.RARE,
        cost: 30,
        weight: 5,
    },




    ESTER_GREASE: {
        item: 'Ester Grease',
        category: CraftingCategory.ALCHEMICAL_TREATMENTS,
        DC: 14,
        maxAmount: 10,
        rarity: Rarity.COMMON,
        cost: 8,
        weight: 0.1,
    },
    ETCHING_ACID: {
        item: 'Etching Acid',
        category: CraftingCategory.ALCHEMICAL_TREATMENTS,
        DC: 14,
        maxAmount: 10,
        rarity: Rarity.COMMON,
        cost: 2,
        weight: 0.1,
    },
    EMERALD_DUST: {
        item: 'Emerald Dust',
        category: CraftingCategory.INGOTS_AND_MINERALS,
        DC: 22,
        maxAmount: 3,
        rarity: Rarity.RARE,
        cost: 90,
        weight: 0.1,
    },



    FEATHERS: {
        item: 'Feathers',
        category: CraftingCategory.HIDES_AND_ANIMAL_PARTS,
        maxAmount: 6,
        rarity: Rarity.EVERYDAY,
        cost: 4,
        weight: 0.1,
    },
    FIFTH_ESSENCE: {
        item: 'Fifth Essence',
        category: CraftingCategory.ALCHEMICAL_TREATMENTS,
        rarity: Rarity.RARE,
        cost: 82,
        weight: 0.1,
    },



    GEMSTONE: {
        item: 'Gemstone',
        category: CraftingCategory.INGOTS_AND_MINERALS,
        DC: 24,
        maxAmount: 3,
        rarity: Rarity.RARE,
        cost: 100,
        weight: 0.1,
    },
    GLASS: {
        item: 'Glass',
        category: CraftingCategory.CRAFTING_MATERIALS,
        rarity: Rarity.UNCOMMON,
        cost: 5,
        weight: 0.5,
    },
    GLOWING_ORE: {
        item: 'Glowing Ore',
        category: CraftingCategory.INGOTS_AND_MINERALS,
        DC: 20,
        maxAmount: 3,
        rarity: Rarity.RARE,
        cost: 80,
        weight: 1,
    },
    GOLD: {
        item: 'Gold',
        category: CraftingCategory.INGOTS_AND_MINERALS,
        DC: 3,
        maxAmount: 18,
        rarity: Rarity.RARE,
        cost: 85,
        weight: 1,
    },



    HARDENED_LEATHER: {
        item: 'Hardened Leather',
        category: CraftingCategory.HIDES_AND_ANIMAL_PARTS,
        rarity: Rarity.UNCOMMON,
        cost: 48,
        weight: 3,
    },
    HARDENED_TIMBER: {
        item: 'Hardened Timber',
        category: CraftingCategory.CRAFTING_MATERIALS,
        rarity: Rarity.UNCOMMON,
        cost: 16,
        weight: 0.1,
    },



    IRON: {
        item: 'Iron',
        category: CraftingCategory.INGOTS_AND_MINERALS,
        DC: 16,
        maxAmount: 6,
        rarity: Rarity.UNCOMMON,
        cost: 30,
        weight: 1.5,
    },



    LEATHER: {
        item: 'Leather',
        category: CraftingCategory.HIDES_AND_ANIMAL_PARTS,
        rarity: Rarity.COMMON,
        cost: 28,
        weight: 2,
    },
    LINEN: {
        item: 'Linen',
        category: CraftingCategory.CRAFTING_MATERIALS,
        rarity: Rarity.COMMON,
        cost: 9,
        weight: 0.1,
    },
    LYRIAN_LEATHER: {
        item: 'Lyrian Leather',
        category: CraftingCategory.HIDES_AND_ANIMAL_PARTS,
        rarity: Rarity.UNCOMMON,
        cost: 60,
        weight: 2,
    },



    MAHAKAMAN_DIMERITIUM: {
        item: 'Mahakaman Dimeritium',
        category: CraftingCategory.INGOTS_AND_MINERALS,
        rarity: Rarity.RARE,
        cost: 300,
        weight: 1,
    },
    MAHAKAMAN_STEEL: {
        item: 'Mahakaman Steel',
        category: CraftingCategory.INGOTS_AND_MINERALS,
        rarity: Rarity.UNCOMMON,
        cost: 114,
        weight: 1,
    },
    METEORITE: {
        item: 'Meteorite',
        category: CraftingCategory.INGOTS_AND_MINERALS,
        DC: 24,
        maxAmount: 3,
        rarity: Rarity.RARE,
        cost: 98,
        weight: 1,
    },



    OGRE_WAX: {
        item: 'Ogre Wax',
        category: CraftingCategory.ALCHEMICAL_TREATMENTS,
        DC: 14,
        maxAmount: 10,
        rarity: Rarity.COMMON,
        cost: 10,
        weight: 0.1,
    },
    OIL: {
        item: 'Oil',
        category: CraftingCategory.CRAFTING_MATERIALS,
        rarity: Rarity.COMMON,
        cost: 3,
        weight: 0.1,
    },



    RESIN: {
        item: 'Resin',
        category: CraftingCategory.CRAFTING_MATERIALS,
        DC: 10,
        maxAmount: 6,
        rarity: Rarity.COMMON,
        cost: 2,
        weight: 0.1,
    },
    RIVER_CLAY: {
        item: 'River Clay',
        category: CraftingCategory.INGOTS_AND_MINERALS,
        DC: 14,
        maxAmount: 6,
        rarity: Rarity.UNCOMMON,
        cost: 5,
        weight: 1.5,
    },



    SHARPENING_GRIT: {
        item: 'Sharpening Grit',
        category: CraftingCategory.ALCHEMICAL_TREATMENTS,
        DC: 16,
        maxAmount: 6,
        rarity: Rarity.UNCOMMON,
        cost: 32,
        weight: 0.1,
    },
    SILK: {
        item: 'Silk',
        category: CraftingCategory.CRAFTING_MATERIALS,
        rarity: Rarity.UNCOMMON,
        cost: 50,
        weight: 0.1,
    },
    SILVER: {
        item: 'Silver',
        category: CraftingCategory.INGOTS_AND_MINERALS,
        DC: 16,
        maxAmount: 3,
        rarity: Rarity.RARE,
        cost: 72,
        weight: 1,
    },
    STEEL: {
        item: 'Steel',
        category: CraftingCategory.INGOTS_AND_MINERALS,
        rarity: Rarity.UNCOMMON,
        cost: 48,
        weight: 1,
    },
    STONE: {
        item: 'Stone',
        category: CraftingCategory.INGOTS_AND_MINERALS,
        DC: 8,
        maxAmount: 12,
        rarity: Rarity.EVERYDAY,
        cost: 4,
        weight: 2,
    },


    TANNING_HERB: {
        item: 'Tanning Herb',
        category: CraftingCategory.ALCHEMICAL_TREATMENTS,
        DC: 14,
        maxAmount: 10,
        rarity: Rarity.COMMON,
        cost: 3,
        weight: 0.1,
    },
    THREAD: {
        item: 'Thread',
        category: CraftingCategory.CRAFTING_MATERIALS,
        rarity: Rarity.COMMON,
        cost: 3,
        weight: 0.1,
    },
    TIMBER: {
        item: 'Timber',
        category: CraftingCategory.CRAFTING_MATERIALS,
        DC: 8,
        maxAmount: 12,
        rarity: Rarity.EVERYDAY,
        cost: 3,
        weight: 1,
    },
    TRETEGOR_STEEL: {
        item: 'Tretegor Steel',
        category: CraftingCategory.INGOTS_AND_MINERALS,
        rarity: Rarity.UNCOMMON,
        cost: 64,
        weight: 1,
    },



    WAX: {
        item: 'Wax',
        category: CraftingCategory.CRAFTING_MATERIALS,
        DC: 12,
        maxAmount: 6,
        rarity: Rarity.COMMON,
        cost: 1,
        weight: 0.1,
    },
    WOLF_HIDE: {
        item: 'Wolf Hide',
        category: CraftingCategory.HIDES_AND_ANIMAL_PARTS,
        amount: 3,
        rarity: Rarity.COMMON,
        cost: 14,
        weight: 3,
    },



    ZERRIKANIAN_POWDER: {
        item: 'Zerrikanian Powder',
        category: CraftingCategory.INGOTS_AND_MINERALS,
        DC: 18,
        maxAmount: 3,
        rarity: Rarity.UNCOMMON,
        cost: 30,
        weight: 0.1,
    },
}



// {
//     item: '',
//     category: CraftingCategory.,
//     DC: ,
//     maxAmount: ,
//     rarity: Rarity.,
//     cost: ,
//     weight: ,
// },